import Link from "next/link"

export default function Highlight1({ subtitle, topTitle, text, reverse }) {
  return (
    <section>
      <div className="my-4 flex justify-center font-['Inter']" tabIndex={0}>
        <div
          className={`${
            reverse
              ? "w-full xl:max-w-7xl lg:max-w-4xl md:max-w-3xl flex flex-col items-center lgjustify-between lg:flex-row-reverse"
              : "w-full xl:max-w-7xl lg:max-w-4xl md:max-w-3xl flex flex-col items-center lg:justify-between lg:flex-row "
          }`}
        >
          <div className="lg:w-1/2 px-16 pt-16 lg:p-16">
            <p className="text-orange-400 font-bold mb-1 lg:mt-0 mt-4">
              WHY CHOOSE US
            </p>
            <h3 className="medium-title">
            We built CKAN and the world&apos;s first data portals
            </h3>
          </div>
          <div className="lg:w-1/2 px-16 py-16 lg:p-16">
            <p className="text-secgray text-lg">Our team is proud to be led by the creator of <Link className="text-maingray underline" href="https://ckan.org" target="_blank">CKAN</Link> himself, <Link href="https://rufuspollock.com" className="text-maingray underline" target="_blank">Dr. Rufus Pollock</Link>, president at Datopian. We built <Link href="https://ckan.org " className="text-black underline" target="_blank">CKAN</Link>, the world&apos;s leading open-source data management platform and the world&apos;s first portals for publishing open data such as <Link href="https://data.gov" className="text-black underline" target="_blank">data.gov</Link> and <Link href="https://data.gov.uk" className="text-black underline" target="_blank">data.gov.uk</Link>.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
